'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useAppliedTheme } from '@/hooks/ui/use-applied-theme';
import { env } from '@/lib/config/env';
import { cn } from '@/lib/ui/utils';
import { LOGO_BETA_SRC_DARK_BACKGROUND, LOGO_BETA_SRC_LIGHT_BACKGROUND, LOGO_SRC_DARK_BACKGROUND, LOGO_SRC_LIGHT_BACKGROUND, logoBetaWidthForHeight, logoWordmarkWidthForHeight } from './constants';
const DEFAULT_LOGO_HEIGHT_PX = 64;
interface MorfiLogoProps {
  /** Logo height in pixels. Width follows the active asset aspect ratio. Default 64. */
  size?: number;
  className?: string;
}
function isBetaLockupEnabled(): boolean {
  return env.NEXT_PUBLIC_EARLY_ACCESS_ENABLED === 'true';
}
function resolveLogoSrc(theme: 'light' | 'dark' | undefined, beta: boolean): string {
  if (beta) {
    return theme === 'dark' ? LOGO_BETA_SRC_DARK_BACKGROUND : LOGO_BETA_SRC_LIGHT_BACKGROUND;
  }
  return theme === 'dark' ? LOGO_SRC_DARK_BACKGROUND : LOGO_SRC_LIGHT_BACKGROUND;
}
export function MorfiLogo(t0) {
  const $ = _c(16);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? DEFAULT_LOGO_HEIGHT_PX : t1;
  const theme = useAppliedTheme();
  let T0;
  let beta;
  let height;
  let t2;
  let width;
  if ($[0] !== size || $[1] !== theme) {
    beta = isBetaLockupEnabled();
    height = size;
    width = beta ? logoBetaWidthForHeight(size) : logoWordmarkWidthForHeight(size);
    T0 = Image;
    t2 = resolveLogoSrc(theme, beta);
    $[0] = size;
    $[1] = theme;
    $[2] = T0;
    $[3] = beta;
    $[4] = height;
    $[5] = t2;
    $[6] = width;
  } else {
    T0 = $[2];
    beta = $[3];
    height = $[4];
    t2 = $[5];
    width = $[6];
  }
  const t3 = beta ? "Morfi Beta" : "Morfi";
  let t4;
  if ($[7] !== className) {
    t4 = cn("block shrink-0 object-contain", className);
    $[7] = className;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== T0 || $[10] !== height || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== width) {
    t5 = <T0 src={t2} alt={t3} width={width} height={height} className={t4} />;
    $[9] = T0;
    $[10] = height;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = width;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}